// extracted by mini-css-extract-plugin
export default {"quotePanel":"finance_index-detail-table_quotePanel","wide":"finance_index-detail-table_wide"};